import React, { lazy } from 'react';
import { CheckCircle2, ArrowRight } from 'lucide-react';
export function Storefronts() {
  const bullets = ['Storefronts and commercial entrances', 'Commercial doors and sidelights', 'Commercial windows and business window replacement', 'Insulated glass units and preglazed window systems', 'Ribbon windows and specialty exterior glass', 'Storefront glass repair and replacement'];
  return <section className="py-20 bg-cream-50 border-t border-neutral-200" data-id="element-768">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-769">
        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-770">
          <div className="order-2 lg:order-1 scroll-slide-left" data-id="element-771">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-md bg-primary-50 text-primary-700 text-xs font-semibold uppercase tracking-wider mb-4" data-id="element-772">
              Exterior Commercial Glass
            </div>
            <h2 className="kosins-heading text-4xl md:text-5xl text-neutral-900 mb-6" data-id="element-773">
              Storefront Glass, Doors & Commercial Windows
            </h2>
            <p className="text-lg text-neutral-600 mb-8 leading-relaxed font-sans" data-id="element-774">
              Make a strong first impression and keep your business secure with
              storefront glass replacement, commercial door glass, business
              window replacement and complete storefront systems built for daily
              commercial use.
            </p>
            <ul className="space-y-3 mb-8 font-sans" data-id="element-775">
              {bullets.map((b, i) => <li key={i} className="flex items-start gap-3" data-id="element-776">
                  <CheckCircle2 className="w-5 h-5 text-primary-600 shrink-0 mt-0.5" data-id="element-777" />
                  <span className="text-neutral-700 font-medium" data-id="element-778">{b}</span>
                </li>)}
            </ul>
            <a href="#quote-form" className="inline-flex items-center gap-2 bg-primary-600 hover:bg-primary-700 text-white font-semibold py-3 px-6 rounded-md transition-colors group uppercase tracking-wider text-sm" data-id="element-779">
              Request Storefront Glass Estimate
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-780" />
            </a>
          </div>

          <div className="order-1 lg:order-2 relative scroll-slide-right" data-id="element-781">
            <div className="relative rounded-md overflow-hidden border border-neutral-200 shadow-lg aspect-[4/3]" data-id="element-782">
              <img src="https://cdn.magicpatterns.com/uploads/wPg2kisimmkuF6tYv3NNFq/comertialpic1.webp" alt="Kosin's Glass commercial storefront glass installation with aluminum curtain wall framing" className="w-full h-full object-cover" loading="lazy" data-id="element-783" />
            </div>
            {/* Decorative accent caption */}
            <div className="hidden md:block absolute -bottom-4 -left-4 bg-white px-5 py-3 rounded-md shadow-md border border-neutral-200" data-id="element-784">
              <div className="text-xs uppercase tracking-widest text-primary-600 font-semibold font-sans" data-id="element-785">
                Retail & Commercial
              </div>
              <div className="kosins-heading text-lg text-neutral-900 leading-tight" data-id="element-786">
                Storefront Glass Systems
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}